<template>
  <div class="transit">
    <tips class="transit-tip">
      <div class="transit-tip__line"> 1. 用户可在此新建"自己的仓库信息"（指属于用户自己的，集中不同供应商货物再整理发货的集散仓信息）；或在此新建“供应商的仓库信息”（用于快速安排物流公司直接到供应商仓库地址上门收件，有利于进一步简化用户操作及提高运营效率）； </div>
      <div class="transit-tip__line"> 2. 用户也可在“采购/产品供应商管理/产品供应商信息目录页”内创建对应产品供应商的仓库信息，改信息也将自动导入到此，用户可在此或“采购/产品供应商管理/产品供应商信息目录页”内同步更新修改信息！ </div>
    </tips>
    <div class="transit-top">
      <div class="transit-top__name">中转仓库列表</div>
      <div class="transit-top__fun">
        <div class="transit-top-item">
          <el-select size="mini" placeholder="请选择地域分类"></el-select>
        </div>
        <div class="transit-top-item">
          <el-select size="mini" placeholder="请选择所在国家"></el-select>
        </div>
        <div class="transit-top-item">
          <el-select size="mini" placeholder="请选择仓储分类"></el-select>
        </div>
        <div class="transit-top-item">
          <el-select size="mini" placeholder="请选择仓库面积"></el-select>
        </div>
        <div class="transit-top-item transit-top-item--input">
          <el-input size="mini" placeholder="请输入搜索省份,城市,负责人等"></el-input>
        </div>
        <div class="transit-top__btn">搜索</div>
        <div class="transit-top__btn" @click="newTransitWarehouseBtnClick">新建仓库信息</div>
      </div>
    </div>
    <div class="transit-table">
      <Table :head="TableHead" height="550" width="1654"></Table>
    </div>
  </div>
</template>

<script>
import { TransitWasehouseSearchData, TransitWarehouseNewModule } from './class'
import Table from 'components/common/Table.vue'
import tips from '../common/tips.vue';
export default {
  name: 'repositoryList',
  components: {
    Table, tips
  },
  data(){
    return {
      searchData: new TransitWasehouseSearchData(),
      TableHead: TransitWarehouseNewModule.NEWTABLEHEAD()
    }
  },
  methods: {
    /**新建中转仓 */
    newTransitWarehouseBtnClick(){
      this.$emit('go', {
        id: 'newWarehouse',
        name: '新建中转仓库',
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.transit{
  width: 1800px;
  &-top{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 0;
    &__name{
      font-weight: bold;
      font-size: 16px;
      color: black;
    }
    &__fun{
      display: flex;
    }
    &-item{
      display: flex;
      align-items: center;
      margin-left: 10px;
      ::v-deep{
        .el-input__inner{
          width: 150px;
        }
      }
      &__name{
        font-size: 14px;
        margin-right: 5px;
      }
      &--input{
        ::v-deep{
          .el-input__inner{
            width: 250px;
          }
        }
      }
    }
    &__btn{
      line-height: 30px;
      padding: 0 15px;
      color: white;
      background: #00a0c7;
      margin-left: 10px;
      &:hover{
        cursor: pointer;
        opacity: .8;
      }
    }
  }
}
</style>
